<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="source_api">Source API</label>
            <select class="form-select" id="source_api" v-model="filters.source_api">
                <option value="">All</option>
                <option>Cinolla</option>
                <option>Iplicit</option>
                <option>WooCommerce</option>
            </select>
        </div>
        <div class="col-md-3 mb-4">
            <label class="form-label" for="payment_date">Payment Date</label>
            <input class="form-control" id="payment_date" type="date" v-model="filters.payment_date">
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="payment_date">Payment Date</sortableTh>
            <th>Source Api</th>
            <th>Amount</th>
            <th>Cinolla Payment</th>
            <th>Cinolla Invoice</th>
            <th>Iplicit Receipt</th>
            <th>Iplicit Invoice</th>
            <th>WooCommerce Payment</th>
            <th>WooCommerce Order</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="created_at">Created at</sortableTh>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="payment in data" :key="payment.id">
                <td>{{ payment.payment_date }}</td>
                <td>
                    {{ payment.source_api }}
                    <span v-if="payment.has_sync_error" class="text-danger">
                        (!)
                    </span>
                </td>
                <td>{{ payment.amount }}</td>
                <td>
                    <i v-if="payment.cinolla_payment" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times" :class="{'text-danger': payment.source_api == 'Cinolla' || payment.source_api == 'Iplicit'}"></i>
                </td>
                <td>
                    <template v-for="check in payment.cinolla_invoice">
                        <i v-if="check" class="fa fa-check text-success"></i>
                        <i v-else class="fa fa-times" :class="{'text-danger': payment.source_api == 'Cinolla' || payment.source_api == 'Iplicit'}"></i>
                    </template>
                </td>
                <td>
                    <i v-if="payment.iplicit_receipt" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td>
                    <template v-for="check in payment.iplicit_invoice">
                        <i v-if="check" class="fa fa-check text-success"></i>
                        <i v-else class="fa fa-times text-danger"></i>
                    </template>
                </td>
                <td>
                    <i v-if="payment.woocommerce_payment" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times" :class="{'text-danger': payment.source_api == 'WooCommerce'}"></i>
                </td>
                <td>
                    <template v-for="check in payment.woocommerce_order">
                        <i v-if="check" class="fa fa-check text-success"></i>
                        <i v-else class="fa fa-times" :class="{'text-danger': payment.source_api == 'WooCommerce'}"></i>
                    </template>
                </td>
                <td>{{ payment.created_at }}</td>
                <td v-html="payment.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const orderBy = ref('created_at');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    source_api: '',
    payment_date: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
